<template>
    <div class="body-panel dataContent">
        <template>
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="$router.push('/materials/edit/' + material.Id)">Назад</a>
                        </p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                               class="file-upload-zone-btn" accept=".xlsx" @change="onImporFileChange()" />
                        <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()">
                            Импорт
                        </button>
                        <button type="button" class="btn" @click.stop="onExportModal()">
                            Экспорт
                        </button>
                        <button type="button" class="btn btn-primary" @click="saveQuestions()">Сохранить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <!--<div class="block-in-page">-->
                <!--<h2 class="margin-bottom-10">Настройка теста</h2>-->
                <!--<div class="form-field">-->
                <!--<input id="QuestSort" name="QuestSort" value="true" type="checkbox" class="input-checkbox" v-model="randomOrder" />-->
                <!--<label for="QuestSort" class="input-checkbox-lbl">Отображать вопросы в случайном порядке</label>-->
                <!--</div>-->
                <!--<div class="form-field">-->
                <!--<label class="input-text-lbl">-->
                <!--На сколько вопросов должен ответить пользователь, чтобы сдать тест?-->
                <!--</label>-->
                <!--<input type="text" class="input-text" placeholder="Количество вопросов" v-model="questionsToPass" />-->
                <!--<span class="field-validation-valid"></span>-->
                <!--</div>-->
                <!--</div>-->
                <div class="block-in-page">
                    <h2 class="margin-bottom-10">Вопросы теста</h2>
                    <div v-for="(question, i) of questions" :key="'w' + i + '_' + backgroundImageKey">
                        <div class="form-field-group">
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Название вопроса
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <input type="text" placeholder="Заголовок"
                                       v-model="question.Name"
                                       v-validate="'required'"
                                       :name="'QuestionName' + i"
                                       :class="['input-text', {'input-error': errors.has('QuestionName' + i) }]" />
                                <span class="field-validation-valid"></span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Тип вопроса
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <drop-down :items="questionTypes"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="question.QuestionType"
                                           @change="onChangeQuestionType(question)"></drop-down>
                            </div>
                            <div class="form-field" style="width:130px;min-width:130px;padding-top:25px">
                                <button type="button" class="btn btn-delete" @click.stop="removeQuestion(i)">
                                    Удалить вопрос
                                </button>
                            </div>
                        </div>
                        <div class="form-field">
                            <input :id="'Active' + i" :name="'Active' + i" v-model="question.Active" type="checkbox" class="input-checkbox" />
                            <label :for="'Active' + i" class="input-checkbox-lbl">Активировать вопрос</label>
                        </div>
                        <div class="form-field-group">
                            <div class="form-field">
                                <div>
                                    <label class="input-text-lbl">
                                        Текст вопроса
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <textarea :name="'QuestionDescription' + i" style="height:150px"
                                              v-model="question.Description"
                                              v-validate="'required'" rows="10"
                                              :class="['input-memo', {'input-error': errors.has('QuestionDescription' + i) }]"></textarea>
                                    <span class="field-validation-valid"></span>
                                </div>

                                <div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Изображения
                                        </label>
                                    </div>
                                    <div class="thumbnail-img-block">
                                        <div class="thumbnail-img" v-for="(img, imgIndex) of question.Images">
                                            <a :href="img.FileData" class="lightzoom" rel="group" v-if="img.FileData">
                                                <img :src="img.FileData" />
                                            </a>
                                            <a :href="img.Image" class="lightzoom" rel="group" v-if="!img.FileData && img.Image">
                                                <img :src="img.Image" />
                                            </a>
                                            <div class="thumbnail-img-delete" @click="removeImage(i, imgIndex)"></div>
                                        </div>
                                    </div>
                                    <div class="file-upload-zone" style="height: 100px;">
                                        <div class="file-upload-zone" style="height:100%;">
                                            <input type="file" :id="'dropFiles' + i" :name="'dropFiles' + i" :ref="'dropFiles' + i" :data-index="i" v-validate="{ rules: { required: false } }" class="file-upload-zone-btn dropFiles" accept=".jpg,.jpeg,.png" multiple />
                                            <label :for="'dropFiles' + i" class="file-upload-zone-lbl">Прикрепите изображения</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-field">
                                <div>
                                    <label class="input-text-lbl">
                                        Фон вопроса для отображения на сайте
                                    </label>
                                </div>
                                <div class="thumbnail-img-block" v-if="question.BackgroundSite.FileData || question.BackgroundSite.FilePath">
                                    <div class="thumbnail-img">
                                        <a :href="question.BackgroundSite.FileData" class="lightzoom" rel="group" v-if="question.BackgroundSite.FileData">
                                            <img :src="question.BackgroundSite.FileData" />
                                        </a>
                                        <a :href="question.BackgroundSite.FilePath" class="lightzoom" rel="group" v-if="!question.BackgroundSite.FileData && question.BackgroundSite.FilePath">
                                            <img :src="question.BackgroundSite.FilePath" />
                                        </a>
                                        <div class="thumbnail-img-delete" @click="removeImageBackground(i, 'site')"></div>
                                    </div>
                                </div>
                                <div class="file-upload-zone" v-else style="height: 100px;">
                                    <drop-zone class="drop-area file-upload-zone" @files-dropped="onDropFilesBackgroundSite" :dataId="i" accept=".jpg,.jpeg,.png" style="height: 100px;">
                                        <input type="file"
                                               class="file-upload-zone-btn" accept=".jpg,.jpeg,.png"
                                               :id="'dropFilesBackgroundSite'+i" :data-fieldid="i" :data-client="'site'"
                                               :ref="'dropFilesBackgroundSite'+i"
                                               name="dropFilesBackground" />
                                        <label id="'dropFilesLblBackgroundSite'+i" :for="'dropFilesBackgroundSite'+i" class="file-upload-zone-lbl">Прикрепите изображение</label>
                                    </drop-zone>
                                </div>
                                <div class="margin-bottom-10">
                                    <label class="input-text-lbl">Выравнивание текста</label>
                                    <drop-down :items="[{Id: 'top', Name: 'По верхнему краю'}, {Id: 'bottom', Name: 'По нижнему краю'}]"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="question.BackgroundSite.Align"></drop-down>
                                </div>
                                <div class="btns margin-bottom-10" v-if="question.BackgroundSite.FileData || question.BackgroundSite.FilePath">
                                    <button type="button" class="btn" @click="onBackgroundPreviewModal(question.BackgroundSite, i, 'site')">Предварительный просмотр</button>
                                </div>
                            </div>
                            <div class="form-field">
                                <div>
                                    <label class="input-text-lbl">
                                        Фон вопроса для отображения в мобильном приложении
                                    </label>
                                </div>
                                <div class="thumbnail-img-block" v-if="question.BackgroundMobile.FileData || question.BackgroundMobile.FilePath">
                                    <div class="thumbnail-img">
                                        <a :href="question.BackgroundMobile.FileData" class="lightzoom" rel="group" v-if="question.BackgroundMobile.FileData">
                                            <img :src="question.BackgroundMobile.FileData" />
                                        </a>
                                        <a :href="question.BackgroundMobile.FilePath" class="lightzoom" rel="group" v-if="!question.BackgroundMobile.FileData && question.BackgroundMobile.FilePath">
                                            <img :src="question.BackgroundMobile.FilePath" />
                                        </a>
                                        <div class="thumbnail-img-delete" @click="removeImageBackground(i, 'mobile')"></div>
                                    </div>
                                </div>
                                <div class="file-upload-zone" v-else style="height: 100px;">
                                    <drop-zone class="drop-area file-upload-zone" @files-dropped="onDropFilesBackgroundMobile" :dataId="i" accept=".jpg,.jpeg,.png" style="height: 100px;">
                                        <input type="file"
                                               class="file-upload-zone-btn" accept=".jpg,.jpeg,.png"
                                               :id="'dropFilesBackgroundMobile'+i" :data-fieldid="i" :data-client="'mobile'"
                                               :ref="'dropFilesBackgroundMobile'+i"
                                               name="dropFilesBackground" />
                                        <label id="'dropFilesLblBackgroundMobile'+i" :for="'dropFilesBackgroundMobile'+i" class="file-upload-zone-lbl">Прикрепите изображение</label>
                                    </drop-zone>
                                </div>
                                <div class="margin-bottom-10">
                                    <label class="input-text-lbl">Выравнивание текста</label>
                                    <drop-down :items="[{Id: 'top', Name: 'По верхнему краю'}, {Id: 'bottom', Name: 'По нижнему краю'}]"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="question.BackgroundMobile.Align"></drop-down>
                                </div>
                                <div class="btns margin-bottom-10" v-if="question.BackgroundMobile.FileData || question.BackgroundMobile.FilePath">
                                    <button type="button" class="btn" @click="onBackgroundPreviewModal(question.BackgroundMobile, i, 'mobile')">Предварительный просмотр</button>
                                </div>
                            </div>
                        </div>

                        <template v-if="question.QuestionType !== 3">
                            <p class="input-text-lbl">Варианты ответов</p>

                            <div v-for="(answer, j) of question.Answers">
                                <div class="form-field-group with-out-lbl">
                                    <div class="form-field">
                                        <input type="text" class="input-text" v-model="answer.Value" placeholder="" />
                                    </div>
                                    <div class="form-field" style="width:160px;min-width:160px">
                                        <input :id="'Correct_q_' + i + '_a_' + j" :name="'Correct_q_' + i + '_a_' + j" value="true" type="checkbox" class="input-checkbox"
                                               v-model="answer.Correct"
                                               @change="onCorrectChange(question, answer)" />
                                        <label :for="'Correct_q_' + i + '_a_' + j" class="input-checkbox-lbl">Правильный ответ</label>
                                    </div>
                                    <div class="form-field" style="width:35px;min-width:35px">
                                        <button type="button" class="btn btn-default btn-img" @click.stop="removeAnswer(question, j)">
                                            <img src="../../../img/icon-del.png" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn btn-primary btn-img" @click="addAnswer(question)">
                                <img src="../../../img/icon-plus-2.png" alt="" />
                            </button>
                        </template>

                        <template v-if="question.QuestionType === 3">
                            <p class="input-text-lbl">Вариант ответа</p>
                            <div class="form-field-group with-out-lbl">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Тип ответа
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <drop-down :items="answerTypes"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="question.AnswerType"
                                               @change="onChangeAnswerType(question)"></drop-down>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Правильный ответ
                                        <span class="required" aria-required="true"></span>
                                    </label>

                                    <input type="text" class="input-text" key="type1"
                                           :name="'QuestionFreeAnswer' + i"
                                           v-model="question.Answers[0].Value"
                                           v-validate="{ required: true }"
                                           :class="['input-text', {'input-error': errors.has('QuestionFreeAnswer' + i) }]"
                                           v-if="question.AnswerType === 1" />

                                    <input type="text" key="type2"
                                           :name="'QuestionFreeAnswer' + i"
                                           v-model="question.Answers[0].Value"
                                           v-if="question.AnswerType === 2"
                                           v-validate="{ required: true, regex: /^\d{1,}$/ }" :class="['input-text', {'input-error': errors.has('QuestionFreeAnswer' + i) }]" />

                                    <input type="text" key="type3"
                                           :name="'QuestionFreeAnswer' + i"
                                           v-model="question.Answers[0].Value"
                                           v-if="question.AnswerType === 3"
                                           v-validate="{ required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }" :class="['input-text', {'input-error': errors.has('QuestionFreeAnswer' + i) }]" />

                                    <input-date key="type4"
                                                :name="'QuestionFreeAnswer' + i"
                                                v-model="question.Answers[0].Value"
                                                v-validate="{ required: true }"
                                                :class="[{'input-error': errors.has('QuestionFreeAnswer' + i)}]"
                                                v-if="question.AnswerType === 4"></input-date>
                                </div>
                            </div>
                        </template>

                        <div class="block-in-page-separator"></div>
                    </div>

                    <button type="button" class="btn btn-primary margin-top-15" @click="addQuestion()">
                        Добавить вопрос
                    </button>
                </div>
            </div>
        </template>

        <popup-window ref="ppExport" :title="'Выгрузка результатов'" :width="800">
            <div class="">
                <div class="form-field flex mob-inline">
                    <input-date name="dateStart" v-model="exportDateStart" class="input-text input-date"></input-date>
                    <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
                    <input-date name="dateEnd" v-model="exportDateEnd" class="input-text input-date"></input-date>
                </div>
                <div class="margin-top-20">
                    <complex-filter ref="complexFilter"
                                    :filters="filters"
                                    :searchFunction="searchFunction"
                                    :tableName="'[dbo].[TradePoint]'"
                                    :withTableNameInClause="true"
                                    @onFilterChange="onFilterChange">
                    </complex-filter>
                </div>
                <div class="margin-top-20 margin-bottom-200">
                    <button type="button" class="btn" @click="onExport()">
                        Готово
                    </button>
                </div>
            </div>
        </popup-window>

        <popup-window ref="ppBackgroundPreview" :title="headerBackgroundPreview">
            <div class="">
                <div class="background-image">
                    <img :src="backgroundImage" />
                    <p :class="[{'top': backgroundImageTop }, {'bottom': !backgroundImageTop }]">{{backgroundImageText}}</p>
                </div>
                <div class="margin-top-20 btns">
                    <button type="button" class="btn" @click.stop="closeModal('ppBackgroundPreview')">Готово</button>
                </div>
            </div>
        </popup-window>

        <vue-headful title="Вопросы к материалу" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import $ from 'jquery'
    import UI from '../../helpers/ui-helpers'
    import projectMixin from '../../helpers/project-mixin'
    import imgMixin from '../../helpers/img-mixin'
    import moment from 'moment'
    import config from '../../config'

    let backendApi = new BackendApi();

    export default {
        name: "questions-edit",

        props: ['info'],

        mixins: [projectMixin, imgMixin],

        data() {
            return {
                questions: [],
                material: null,
                randomOrder: false,
                questionsToPass: null,
                questionTypes: [
                    { Id: 1, Name: 'Один из списка' },
                    { Id: 2, Name: 'Несколько из списка' },
                    { Id: 3, Name: 'Свободный' }
                ],
                answerTypes: [
                    { Id: 1, Name: 'Текст' },
                    { Id: 2, Name: 'Целое число' },
                    { Id: 3, Name: 'Дробное число' },
                    { Id: 4, Name: 'Дата' }
                ],
                importResult: null,
                exportDateStart: null,
                exportDateEnd: null,
                exportFilter: null,
                filters: [],
                roles: [],
                backgroundImage: null,
                backgroundImageTop: true,
                backgroundImageText: '',
                backgroundImageKey: 0,
                headerBackgroundPreview: ''
            }
        },

        methods: {

            onImporFileChange() {
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        vm.importResult = null;

                        UI.blockUI('.dataContent');
                        this.callApiWrapper(backendApi.materialQuestionsImport(data)).then(function (response) {
                            document.getElementById('dropFiles').value = '';
                            if (response.hasError) {
                                UI.toastr.error('Ошибка импорта');
                            }
                            else {
                                if (response.data) {
                                    vm.importResult = response.data;

                                    if(vm.importResult.Data.length){
                                        for(let q of vm.importResult.Data){
                                            vm.questions.push(q);
                                        }
                                    }
                                }
                            }
                            UI.unblockUI('.dataContent');
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            back() {
                this.$router.back();
            },

            onChangeDate(answer){
                answer['Value'] =  moment(answer['date'], 'DD.MM.YYYY').format('DD.MM.YYYY');
            },

            onChangeAnswerType(question) {
                if (question.Answers.length === 1) {
                    question.Answers[0].Value = '';
                }
            },

            addQuestion() {
                this.questions.push({
                    Id: 0,
                    QuestionType: 1,
                    Answers: [{
                        Id: 0,
                        Value: 'Вариант-1'
                    }],
                    AnswerType: 1,
                    Images: [],
                    BackgroundSite: {},
                    BackgroundMobile: {}
                })
            },

            removeQuestion(i) {
                this.questions.splice(i, 1);
            },

            addAnswer(question) {
                question.Answers.push({
                    Id: 0
                })
            },

            removeAnswer(question, j) {
                question.Answers.splice(j, 1);
            },

            onChangeQuestionType(question) {
                if (question.QuestionType === 3) {
                    question.Answers = [{}];
                    question.AnswerType = 1;
                } else {
                    question.AnswerType = null;

                    if(question.QuestionType === 1) // один из списка
                    {
                        let filtered = question.Answers.filter(x => x.Correct);
                        if(filtered.length) {
                            for (let a of filtered) {
                                a.Correct = false;
                            }
                            filtered[0].Correct = true;
                        }
                    }
                }
            },

            onCorrectChange(question, answer) {
                // один из списка
                if (question.QuestionType === 1 && answer.Correct) {
                    for (let a of question.Answers) {
                        a.Correct = false;
                    }
                    answer.Correct = true;
                }
            },

            loadQuestions() {
                let vm = this;

                let materialId = parseInt(this.$route.params.id);
                if (materialId === 0) {

                    vm.$router.back();

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.materialLoad(materialId).then(function (response) {
                        //console.info('project.edit -> load, response:', response.data);
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке материала');
                        }
                        else {
                            if (response.data == null) {
                                vm.$router.back();
                            }

                            vm.material = response.data;
                            vm.questions = response.data.Questions || [];
                            vm.randomOrder = response.data.RandomOrder;
                            vm.questionsToPass = response.data.QuestionsToPass;
                        }
                    })
                }
            },

            loadRoles() {
                let vm = this;
                let projectId = vm.material.ProjectId;
                vm.filters = [
                    {
                        Value: 'Name', Name: 'Название'
                    },
                    {
                        Value: 'Region', Name: 'Область'
                    },
                    {
                        Value: 'City', Name: 'Город'
                    },
                    {
                        Value: 'Address', Name: 'Адрес'
                    }
                ];
                return this.callApiWrapper(backendApi.rolesList(projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            vm.roles = resp.data.Roles;

                            /*
                            для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                            если роль не связана с ТТ, то она видит все роли связанные с ТТ
                            если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                            */
                            if(vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess))
                            {
                                //alert()
                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                            }
                            else{

                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess) && vm.info.User.DynamicRole.Order < vm.roles[r].Order) {

                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                            }
                        }
                    });
            },

            saveQuestions() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else if(vm.questions.length &&!vm.questions.filter(x => x.Active === true).length)
                    {
                        UI.toastr.error('Нужен хотя бы один активный вопрос');
                    }
                    else {
                        UI.blockUI('.dataContent', 'Сохранение...');

                        let materialId = parseInt(this.$route.params.id);
                        let saveObj = {
                            MaterialId: materialId,
                            Questions: vm.questions,
                            RandomOrder: vm.randomOrder,
                            QuestionsToPass: vm.questionsToPass
                        };

                        for(let q of saveObj.Questions){
                            if(q.QuestionType === 3 && q.Answers.length === 1){
                                q.Answers[0].Correct = true;
                            }
                        }

                        //console.info('saveObj', saveObj);

                        backendApi.materialQuestionsSave(saveObj).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                if(response.status === 701){
                                    UI.toastr.error('Неверное значение количества обязательных вопросов');
                                }else{
                                    UI.toastr.error('Ошибка при сохранении вопросов');
                                }

                            } else {
                                UI.toastr.success('Успешно сохранено');

                                vm.loadQuestions();
                            }
                        });
                    }
                });
            },

            onExportModal(){
                this.onShowModal('ppExport');
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let vm = this;
                let materialId = parseInt(this.$route.params.id);
                //let projectId = vm.material.ProjectId;
                let filterFormatted = '';
                if(filters){
                    filterFormatted = filters.map(x => {return JSON.stringify(x)});
                }

                this.callApiWrapper(backendApi.materialResultsExportDistinctValues(columnName, materialId, search, filterFormatted, (searchPage - 1) * 30, 30))
                    .then(function (resp) {
                        callback(resp.data);
                    })

            },

            onFilterChange(filter) {
                this.exportFilter = filter;
            },

            onExport() {
                let vm = this;
                let dateStart = moment(vm.exportDateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.exportDateEnd, 'DD.MM.YYYY').format();
                let materialId = parseInt(vm.$route.params.id);

                let filterFormatted = '';
                if(vm.exportFilter){
                    filterFormatted = vm.exportFilter.map(x => {return JSON.stringify(x)});
                }

                UI.blockUI('.popup');

                this.callApiWrapper(backendApi.materialResultsExport(materialId, filterFormatted, dateStart, dateEnd))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта результатов тетса');
                        }
                        else {
                            //let exportFile = resp.data;
                            //location.href = config.apiUrl + '/api/materials/results/exported?exportFile=' + exportFile;
                            UI.downloadFileByBytes(resp.data, "Тесты. Выгрузка результатов.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                        }

                        UI.unblockUI('.popup');
                    });
            },

            removeImage(questionIndex, imageIndex){
                if(confirm('Удалить файл?')) {
                    this.questions[questionIndex].Images.splice(imageIndex, 1);
                    this.$refs['dropFiles' + questionIndex].value = '';
                }
            },

            removeImageBackground(questionIndex, clientType) {
                if (confirm('Удалить файл?')) {
                    if (clientType === 'site') {
                        this.questions[questionIndex].BackgroundSite.FileData = '';
                        this.questions[questionIndex].BackgroundSite.FilePath = '';
                        this.questions[questionIndex].BackgroundSite.FileName = '';
                    } else if (clientType === 'mobile') {
                        this.questions[questionIndex].BackgroundMobile.FileData = '';
                        this.questions[questionIndex].BackgroundMobile.FilePath = '';
                        this.questions[questionIndex].BackgroundMobile.FileName = '';
                    }
                    this.backgroundImageKey+=1;
                }
            },

            onDropFilesBackgroundSite(obj) {
                obj.client = 'site';
                this.onDropFilesBackground(obj);
            },

            onDropFilesBackgroundMobile(obj) {
                obj.client = 'mobile';
                this.onDropFilesBackground(obj);
            },

            onDropFilesBackground(obj) {
                let files = obj.files;
                let fieldId = obj.id;
                let client = obj.client;
                let filename = '';
                //console.info('onDropFilesBackground', obj);
                let vm = this;
                if (files && files.length) {
                    for (let file of files) {
                        filename = file.name.toLowerCase();
                        if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png')) {
                            if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFiles"]').val('');
                            } else {
                                //console.info('file:', filename.indexOf('.doc'), filename);
                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    if (client === 'site') {
                                        vm.questions[fieldId].BackgroundSite.FileName = file.name;
                                        vm.questions[fieldId].BackgroundSite.FileData = e.target.result;
                                    }
                                    else if (client === 'mobile') {
                                        vm.questions[fieldId].BackgroundMobile.FileName = file.name;
                                        vm.questions[fieldId].BackgroundMobile.FileData = e.target.result;
                                    }
                                    vm.backgroundImageKey += 1;
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                        else {
                            UI.toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png');
                        }
                    }
                }
            },

            onBackgroundPreviewModal(background, i, client) {
                let vm = this;
                if (background.FileData) vm.backgroundImage = background.FileData;
                else vm.backgroundImage = background.FilePath;
                vm.backgroundImageText = vm.questions[i].Description;
                vm.backgroundImageTop = background.Align === 'top';
                if (client === 'site') {
                    vm.headerBackgroundPreview = 'Предварительный просмотр отображения вопроса на сайте';
                }
                else {
                    vm.headerBackgroundPreview = 'Предварительный просмотр отображения вопроса в мобильном приложении';
                }
                this.onShowModal('ppBackgroundPreview');
            },

            closeModal(popupName) {
                this.$refs[popupName].close();
            },
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            this.loadQuestions().then(() => {

                UI.unblockUI('.dataContent');
                vm.loadRoles();

                $(document).on('change', '[name="dropFilesBackground"]', function () {
                    let fieldId = $(this).data('fieldid');
                    let client = $(this).data('client');
                    //console.info('atDropFiles2 -> typeId:', fieldId, $(this)[0].accept, client)
                    if (client === 'site') {
                        vm.onDropFilesBackgroundSite({ files: this.files, id: fieldId, accept: $(this)[0].accept, client: client });
                    } else {
                        vm.onDropFilesBackgroundMobile({ files: this.files, id: fieldId, accept: $(this)[0].accept, client: client });
                    }
                });

                vm.imgmixin_lightzoomInit();
            });

            $(document).on('change', '.dropFiles', function () {
                let $this = $(this);
                if (this.files && this.files.length) {
                    for (let file of this.files) {
                        if (file.size > 50 * 1024 * 1024) {
                            UI.toastr.error('Превышен размер. Выберите другой файл');
                            $this.val('');
                        } else {
                            let img = {FileName: file.name, FileData: null, Delete: false};
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                img.FileData = e.target.result;

                                let questionIndex = parseInt($this.data('index'));
                                vm.questions[questionIndex].Images.push(img);

                                vm.$nextTick(() => {
                                    vm.imgmixin_lightzoomInit();
                                });
                            };
                            reader.readAsDataURL(file);
                        }
                    }
                }
            });

        },

        destroyed() {

        }
    }
</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/QuestionsEdit.vue